import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/up-yong-text-pc.png'
import _imports_1 from '../assets/img/code-wrap.png'
import _imports_2 from '../assets/img/qrcode.png'
import _imports_3 from '../assets/img/qrcode188.png'
import _imports_4 from '../assets/img/up-yong-logo.png'
import _imports_5 from '../assets/img/up-yong-text.png'
import _imports_6 from '../assets/img/icon/share.png'


const _withScopeId = n => (_pushScopeId("data-v-bfec3490"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "download" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "info-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "text-img",
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_5 = { class: "code-wrap" }
const _hoisted_6 = { class: "img-box" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "code-box",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "qr-code",
  src: _imports_2,
  alt: ""
}
const _hoisted_9 = {
  key: 1,
  class: "qr-code",
  src: _imports_3,
  alt: ""
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, "手机扫码 下载App", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "up-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_4,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-info" }, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_5,
      alt: ""
    })
  ])
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  alt: ""
}, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请选择默认浏览器打开并下载", -1))
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

import { downloadApp } from '../common/utill';
import { computed, ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tips = ref(false);
const devImage = computed(() => {
  return process.env.VUE_APP_ENV === 'production';
});
const goDownLoad = () => {
  const openTips = downloadApp();
  if (openTips) {
    tips.value = true;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_unref(devImage))
              ? (_openBlock(), _createElementBlock("img", _hoisted_8))
              : (_openBlock(), _createElementBlock("img", _hoisted_9))
          ]),
          _hoisted_10
        ])
      ]),
      _createElementVNode("div", { class: "m-content" }, [
        _hoisted_11,
        _createElementVNode("div", {
          class: "btn",
          onClick: goDownLoad
        }, " 立即下载App ")
      ])
    ]),
    (tips.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "share-bg",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (tips.value = false))
        }, _hoisted_14))
      : _createCommentVNode("", true)
  ]))
}
}

})